/* Sense Of Unique — blocs dépliables de la fiche produit (mobile et tablette)
   "Le geste" et "Formulation / INCI" sont repliés en dessous de 990 px et restent
   toujours ouverts sur ordinateur. Sans JavaScript, les blocs restent ouverts.
   Cible le balisage de sections/main-product.liquid : .sou-two-col > .sou-col */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 989px)');

  function build(col) {
    if (col.querySelector('.sou-fold')) return;
    if (!col.querySelector('.sou-protocol, .sou-inci, .sou-cert-tags')) return;
    var head = col.querySelector('.sou-col-title') || col.querySelector('.sou-label');
    if (!head) return;
    var fold = document.createElement('details');
    fold.className = 'sou-fold';
    fold.open = true;
    var summary = document.createElement('summary');
    summary.className = 'sou-col-title sou-fold__summary';
    summary.textContent = head.textContent;
    fold.appendChild(summary);
    var nodes = Array.prototype.slice.call(col.childNodes);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i] !== head) fold.appendChild(nodes[i]);
    }
    col.removeChild(head);
    col.appendChild(fold);
  }

  function sync() {
    var folds = document.querySelectorAll('.sou-fold');
    for (var i = 0; i < folds.length; i++) folds[i].open = !mq.matches;
  }

  function init() {
    var cols = document.querySelectorAll('.sou-two-col > .sou-col');
    for (var i = 0; i < cols.length; i++) build(cols[i]);
    sync();
  }

  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);

  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('sou-fold') && !mq.matches && !t.open) t.open = true;
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
